<template>
  <b-form>
    <div
      class="row mb-3 pb-3 border-bottom g-0"
      style="--bs-border-color: black"
    >
      <div class="col-md-6 d-flex align-items-center">
        <span class="fw-bold">Surat Pengantar Laporan Tahunan</span>
      </div>
      <div class="col-md-6 ps-4">
        <div class="row">
          <div>
            <small
              >Format file: PDF, Ukuran maksimal: 5MB
              <span class="text-danger">*</span></small
            >
            <i
              class="fa fa-info-circle ml-1"
              v-b-tooltip.hover.topright="
                'Silahkan upload Surat Pengantar sebelum mengisi form'
              "
            />
          </div>
          <div class="col-6">
            <b-form-file
              v-model="form.surat_pengantar"
              id="surat_pengantar"
              plain
              class="form-control"
              name="Surat Pengantar"
              accept=".pdf"
              @change="checkFileSize($event, 'surat-pengantar')"
              :disabled="is_selesai"
            ></b-form-file>
          </div>
          <div class="col-6 d-flex">
            <a
              v-if="!is_selesai"
              :class="[
                'btn btn-primary mr-2 text-white',
                { disabled: form.surat_pengantar === null },
              ]"
              @click="uploadFile"
            >
              <i class="fa fa-cloud-upload" />
              Unggah
            </a>
            <a
              :class="{
                'btn btn-success': true,
                disabled: url_surat_pengantar === null,
              }"
              :href="url_surat_pengantar"
              target="_blank"
            >
              <i class="fa fa-download" />
              Unduh
            </a>
          </div>
        </div>
        <span class="text-danger" v-if="errors.has('Surat Pengantar')">
          {{ errors.first('Surat Pengantar') }}
        </span>
        <span
          class="text-danger"
          v-if="errors.has('surat-pengantar', 'custom')"
        >
          {{ errors.first('surat-pengantar', 'custom') }}
        </span>
      </div>
    </div>
    <legend class="text-black fw-bold">
      Identitas Pemegang Persetujuan/Konfirmasi
    </legend>
    <div
      :class="[
        'row mb-5',
        { 'pe-none opacity-75': !sudah_upload_surat_pengantar },
      ]"
    >
      <div class="col-md-6">
        <label>Nomor KKPRL/Nomor OSS <span class="text-danger">*</span></label>
        <i
          class="fa fa-info-circle ml-1"
          v-b-tooltip.hover.topright="
            'Jika Nomor KKPRL/Nomor OSS tersedia, form akan otomatis terisi setelah memilih Jenis Kegiatan, jika tidak tersedia silahkan isi form secara manual'
          "
        />
        <b-form-input
          v-model="form.no_kkprl"
          id="nomor_kkprl"
          v-validate="'required'"
          name="Nomor KKPRL"
          :class="{ input: true, 'is-danger': errors.has('Nomor KKPRL') }"
          :disabled="is_selesai"
          style="background-color: white"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Nomor KKPRL')">
          {{ errors.first('Nomor KKPRL') }}
        </span>
      </div>
      <div class="col-md-6">
        <label>Jenis Kegiatan <span class="text-danger">*</span></label>
        <v-select
          v-model="form.jenis_kegiatan"
          id="tahun_laporan"
          :reduce="(data) => data.value"
          label="text"
          :options="optionJenisKegiatan"
          name="Jenis Kegiatan"
          v-validate="'required'"
          @input="getPermohonan"
          :class="{ 'pe-none': is_selesai }"
        />
        <span class="text-danger" v-if="errors.has('Jenis Kegiatan')">
          {{ errors.first('Jenis Kegiatan') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Tahun Laporan <span class="text-danger">*</span></label>
        <v-select
          v-model="form.tahun_laporan"
          id="tahun_laporan"
          :reduce="(data) => data.value"
          label="text"
          :options="optionTahunLaporan"
          name="Tahun Laporan"
          v-validate="'required'"
          @input="checkLaporanIsAvailable"
          :class="{ 'pe-none': is_selesai }"
        />
        <span class="text-danger" v-if="errors.has('Tahun Laporan')">
          {{ errors.first('Tahun Laporan') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label
          >Tanggal Penerbitan KKPRL <span class="text-danger">*</span></label
        >
        <DatePicker
          id="tgl_penerbitan"
          lang="en"
          :placeholder="tgl_penerbitan"
          input-class="form-control"
          @change="
            (val) => {
              this.tgl_penerbitan = val.toLocaleDateString('en-GB')
              this.form.tgl_penerbitan = formatDate(val, 'YYYY-MM-DD')
              this.errors.remove('Tanggal Penerbitan')
            }
          "
          :class="['w-100', { 'pe-none': is_selesai }]"
        >
          <i class="fa fa-calendar-o" slot="calendar-icon" />
        </DatePicker>
        <span class="text-danger" v-if="errors.has('Tanggal Penerbitan')">
          {{ errors.first('Tanggal Penerbitan') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label
          >Nama Pemegang (Sesuai dengan KKPRL Terbit)
          <span class="text-danger">*</span></label
        >
        <b-form-input
          v-model="form.nama_pemegang"
          id="nama_pemegang"
          v-validate="'required'"
          name="Nama Pemegang"
          :class="{
            input: true,
            'is-danger': errors.has('Nama Pemegang'),
          }"
          :disabled="is_selesai"
          style="background-color: white"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Nama Pemegang')">
          {{ errors.first('Nama Pemegang') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label
          >Nomor Pokok Wajib Pajak <span class="text-danger">*</span></label
        >
        <b-form-input
          v-model="form.npwp"
          id="npwp"
          v-mask="'##.###.###.#-###.####'"
          v-validate="'required'"
          name="NPWP"
          :class="{ input: true, 'is-danger': errors.has('NPWP') }"
          :disabled="is_selesai"
          style="background-color: white"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('NPWP')">
          {{ errors.first('NPWP') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Alamat Kantor <span class="text-danger">*</span></label>
        <b-form-textarea
          name="Alamat Kantor"
          v-validate="'required'"
          v-model="form.alamat_kantor"
          id="alamat_kantor"
          rows="3"
          :disabled="is_selesai"
          style="background-color: white"
        ></b-form-textarea>
        <span class="text-danger" v-if="errors.has('Alamat Kantor')">
          {{ errors.first('Alamat Kantor') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Nomor Telepon/Faksimil <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.no_telepon"
          id="no_telepon"
          v-mask="'#############'"
          v-validate="'required'"
          name="No Telepon"
          :class="{
            input: true,
            'is-danger': errors.has('No Telepon'),
          }"
          :disabled="is_selesai"
          style="background-color: white"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('No Telepon')">
          {{ errors.first('No Telepon') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Surat Elektronik <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.surat_elektronik"
          id="surat_elektronik"
          v-validate="'required|email'"
          name="Surat Elektronik"
          :class="{
            input: true,
            'is-danger': errors.has('Surat Elektronik'),
          }"
          :disabled="is_selesai"
          style="background-color: white"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Surat Elektronik')">
          {{ errors.first('Surat Elektronik') }}
        </span>
        <span
          class="text-danger"
          v-if="
            errors.has('email_validation') && !errors.has('Surat Elektronik')
          "
        >
          {{ errors.first('email_validation') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Status Penanaman Modal <span class="text-danger">*</span></label>
        <v-select
          v-model="form.status_penanaman_modal"
          id="status_penanaman_modal"
          :reduce="(data) => data.value"
          label="text"
          :options="optionStatusPenanamanModal"
          name="Status Penanaman"
          v-validate="'required'"
          :class="{ 'pe-none': is_selesai }"
        />
        <b-form-input
          v-if="form.status_penanaman_modal === 'Lainnya'"
          v-model="form.status_penanaman_modal_lainnya"
          id="status_penanaman_modal_lainya"
          v-validate="'required'"
          name="Status Penanaman"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Status Penanaman')">
          {{ errors.first('Status Penanaman') }}
        </span>
      </div>
    </div>

    <legend class="text-black fw-bold">Identitas Penanggung Jawab</legend>
    <div
      :class="[
        'row',
        { 'pe-none opacity-75': !sudah_upload_surat_pengantar },
        { 'pe-none': is_selesai },
      ]"
    >
      <div class="col-md-6">
        <label>Nama Penanggung Jawab <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.nama_penanggung_jawab"
          id="nama_penanggung_jawab"
          v-validate="'required'"
          name="Nama Penanggung Jawab"
          :class="{
            input: true,
            'is-danger': errors.has('Nama Penanggung Jawab'),
          }"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Nama Penanggung Jawab')">
          {{ errors.first('Nama Penanggung Jawab') }}
        </span>
      </div>
      <div class="col-md-6">
        <label
          >Jabatan Penanggung Jawab <span class="text-danger">*</span></label
        >
        <b-form-input
          v-model="form.jabatan_penanggung_jawab"
          id="jabatan_penanggung_jawab"
          v-validate="'required'"
          name="Jabatan Penanggung Jawab"
          :class="{
            input: true,
            'is-danger': errors.has('Jabatan Penanggung Jawab'),
          }"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Jabatan Penanggung Jawab')">
          {{ errors.first('Jabatan Penanggung Jawab') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Nomor Telepon Seluler <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.no_telepon_penanggung_jawab"
          id="no_telepon_penanggung_jawab"
          v-mask="'#############'"
          v-validate="'required'"
          name="No Telepon Penanggung Jawab"
          :class="{
            input: true,
            'is-danger': errors.has('No Telepon Penanggung Jawab'),
          }"
        ></b-form-input>
        <span
          class="text-danger"
          v-if="errors.has('No Telepon Penanggung Jawab')"
        >
          {{ errors.first('No Telepon Penanggung Jawab') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Surat Elektronik <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.surel_penanggung_jawab"
          id="surel_penanggung_jawab"
          v-validate="'required|email'"
          name="Surat Elektronik Penanggung Jawab"
          :class="{
            input: true,
            'is-danger': errors.has('Surat Elektronik Penanggung Jawab'),
          }"
        ></b-form-input>
        <span
          class="text-danger"
          v-if="errors.has('Surat Elektronik Penanggung Jawab')"
        >
          {{ errors.first('Surat Elektronik Penanggung Jawab') }}
        </span>
        <span
          class="text-danger"
          v-if="
            errors.has('email_validation2') &&
            !errors.has('Surat Elektronik Penanggung Jawab')
          "
        >
          {{ errors.first('email_validation2') }}
        </span>
      </div>
    </div>

    <div class="mt-5 fw-bold">
      Note: tanda (<span class="text-danger">*</span>) wajib diisi
    </div>
  </b-form>
</template>

<script>
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import { formatDate } from '../../helper/helpernew'
import axios from 'axios'
import Swal from 'sweetalert2'
import { telpMask } from '../../helper/validationHelper'

export default {
  components: {
    vSelect,
    DatePicker,
  },
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      no_oss: null,
      form: {
        surat_pengantar: null,
        no_kkprl: '',
        jenis_kegiatan: '',
        tahun_laporan: '',
        tgl_penerbitan: null,
        nama_pemegang: '',
        npwp: '',
        alamat_kantor: '',
        no_telepon: '',
        surat_elektronik: '',
        status_penanaman_modal: '',
        status_penanaman_modal_lainnya: '',
        nama_penanggung_jawab: '',
        jabatan_penanggung_jawab: '',
        no_telepon_penanggung_jawab: '',
        surel_penanggung_jawab: '',
      },
      is_selesai: false,
      sudah_upload_surat_pengantar: false,
      url_surat_pengantar: null,
      tgl_penerbitan: 'dd/mm/yyyy',
      optionTahunLaporan: [],
      // prettier-ignore
      optionStatusPenanamanModal: [
        { value: 'Penanaman Modal Dalam Negeri (PMDN)', text: 'Penanaman Modal Dalam Negeri (PMDN)', },
        { value: 'Penanaman Modal Asing (PMA)', text: 'Penanaman Modal Asing (PMA)', },
        { value: 'Lainnya', text: 'Lainnya', },
        { value: 'Tidak Ada', text: 'Tidak Ada', },
      ],
      // prettier-ignore
      optionJenisKegiatan: [
        { value: 'Berusaha', text: 'Berusaha', },
        { value: 'Non Berusaha', text: 'Non Berusaha', },
      ],
    }
  },
  mounted() {
    this.getTahunLaporan()
    this.loadLaporanTahunan()
  },
  methods: {
    telpMask,
    formatDate,

    uploadFile() {
      this.$loading(true)
      const formData = new FormData()
      formData.append('file_surat_pengantar', this.form.surat_pengantar)

      if (!this.$route.query.id_laporan) {
        axios
          .post(this.baseapi + 'api/laporan_tahunan', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ` + this.user.accessToken,
            },
          })
          .then(async (res) => {
            this.$toasted.success('Berhasil Diunggah')
            this.$router.replace({
              path: this.$route.path,
              query: { id_laporan: res.data.data.id },
            })
            this.sudah_upload_surat_pengantar = true
            this.url_surat_pengantar = res.data.data.file_surat_pengantar
            this.form.surat_pengantar = null
          })
          .catch((err) => {
            this.$toasted.danger('Gagal Diunggah')
          })
          .finally(() => {
            this.$loading(false)
          })
      } else {
        axios
          .post(
            this.baseapi +
              'api/laporan_tahunan/' +
              this.$route.query.id_laporan,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ` + this.user.accessToken,
              },
            }
          )
          .then(async (res) => {
            this.$toasted.success('Berhasil Diunggah')
            this.url_surat_pengantar = res.data.data.file_surat_pengantar
            this.form.surat_pengantar = null
          })
          .catch((err) => {
            this.$toasted.danger('Gagal Diunggah')
          })
          .finally(() => {
            this.$loading(false)
          })
      }
    },

    async nextForm() {
      if (this.is_selesai) {
        return true
      }

      if (this.form.tgl_penerbitan === null) {
        this.errors.add({
          field: 'Tanggal Penerbitan',
          msg: 'Tanggal Penerbitan wajib diisi',
        })
      }

      if ((await this.$validator.validateAll()) && !this.errors.any()) {
        this.$loading(true)
        const formData = new FormData()
        // prettier-ignore
        {
          formData.append('nomor_kkprl', this.form.no_kkprl.replaceAll(" ", ''))
          formData.append('tahun_laporan', this.form.tahun_laporan)
          formData.append('jenis_kegiatan', this.form.jenis_kegiatan)
          formData.append('nama_pemegang', this.form.nama_pemegang)
          formData.append('alamat_kantor', this.form.alamat_kantor)
          formData.append('email', this.form.surat_elektronik)
          formData.append('tanggal_penerbitan', this.form.tgl_penerbitan)
          formData.append('npwp', this.form.npwp)
          formData.append('no_telepon', this.form.no_telepon)
          if (this.form.status_penanaman_modal !== 'Lainnya') {
            formData.append('status_penanaman_modal', this.form.status_penanaman_modal)
          } else {
            formData.append('status_penanaman_modal', this.form.status_penanaman_modal_lainnya)
          }
          formData.append('nama_penanggungjawab', this.form.nama_penanggung_jawab)
          formData.append('jabatan_penanggungjawab', this.form.jabatan_penanggung_jawab)
          formData.append('no_hp_penanggungjawab', this.form.no_telepon_penanggung_jawab)
          formData.append('email_penanggungjawab', this.form.surel_penanggung_jawab)
        }

        return axios
          .post(
            this.baseapi +
              `api/laporan_tahunan/${this.$route.query.id_laporan}`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ` + this.user.accessToken,
              },
            }
          )
          .then(async (res) => {
            Swal.fire(
              'Berhasil',
              'Identitas Laporan Tahunan tersimpan',
              'success'
            )
            return true
          })
          .catch((err) => {
            Swal.fire('Gagal', 'Terjadi kesalahan', 'error')
            return false
          })
          .finally(() => {
            this.$loading(false)
          })
      } else {
        return false
      }
    },

    loadLaporanTahunan() {
      if (!this.$route.query.id_laporan) {
        return
      }

      this.$loading(true)
      axios
        .get(
          `${this.baseapi}api/laporan_tahunan/${this.$route.query.id_laporan}`,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((res) => {
          this.sudah_upload_surat_pengantar = true
          const data = res.data.data
          this.is_selesai =
            data.status_laporan !== null &&
            data.status_laporan !== 'Draft' &&
            data.status_laporan !==
              'Komentar/Informasi terhadap Penyampaian Laporan Tahunan'
          Object.assign(this.form, {
            no_kkprl: data.nomor_kkprl || '',
            tahun_laporan: data.tahun_laporan || '',
            jenis_kegiatan: data.jenis_kegiatan || '',
            tgl_penerbitan: data.tanggal_penerbitan,
            nama_pemegang: data.nama_pemegang || '',
            npwp: data.npwp || '',
            alamat_kantor: data.alamat_kantor || '',
            no_telepon: data.no_telepon || '',
            surat_elektronik: data.email || '',
            nama_penanggung_jawab: data.nama_penanggungjawab || '',
            jabatan_penanggung_jawab: data.jabatan_penanggungjawab || '',
            no_telepon_penanggung_jawab: data.no_hp_penanggungjawab || '',
            surel_penanggung_jawab: data.email_penanggungjawab || '',
          })
          // prettier-ignore
          if (!this.optionStatusPenanamanModal.find((d) => d.value === data.status_penanaman_modal)) {
            this.form.status_penanaman_modal = 'Lainnya'
            this.form.status_penanaman_modal_lainnya = data.status_penanaman_modal
          } else {
            this.form.status_penanaman_modal = data.status_penanaman_modal
          }
          this.url_surat_pengantar = data.file_surat_pengantar
          this.tgl_penerbitan = formatDate(
            data.tanggal_penerbitan,
            'DD/MM/YYYY'
          )
        })
        .catch((err) => {
          Swal.fire('Gagal', 'Terjadi kesalahan saat mengambil data', 'error')
        })
        .finally(() => {
          this.$loading(false)
        })
    },

    checkLaporanIsAvailable() {
      axios
        .get(
          this.baseapi +
            `api/laporan_tahunan?filter=nomor_kkprl,=,${this.form.no_kkprl};tahun_laporan,=,${this.form.tahun_laporan}`,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((res) => {
          if (res.data.data.length > 0) {
            Swal.fire(
              `Laporan tahunan tahun ${this.form.tahun_laporan} sudah dilaporkan`,
              '',
              'info'
            ).then((res) => {
              this.form.tahun_laporan = ''
            })
          }
        })
    },

    async getPermohonan() {
      let isKkprlAda = true
      if (this.form.jenis_kegiatan === 'Berusaha') {
        await axios
          .get(
            this.baseapi +
              `api/permohonan?filter=nomor_oss,=,${this.form.no_kkprl}`,
            {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            }
          )
          .then((res) => {
            const data = res.data.data[0]
            if (data) {
              this.form.nama_pemegang = data.nama_pemohon
              this.form.tgl_penerbitan = data.tanggal_terbit_oss
              this.form.npwp = data.npwp_pemohon
              this.form.surat_elektronik = data.email_pemohon
              this.form.alamat_kantor = ''
              this.form.no_telepon = ''
              this.tgl_penerbitan = data.tanggal_terbit_oss
                ? formatDate(data.tanggal_terbit_oss, 'DD/MM/YYYY')
                : 'dd/mm/yyyy'
            } else {
              isKkprlAda = false
            }
          })
      } else {
        await axios
          .get(
            this.baseapi +
              `api/permohonan_nonberusaha?filter=nomor_kkp,=,${this.form.no_kkprl}`,
            {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            }
          )
          .then((res) => {
            const data = res.data.data[0]
            if (data) {
              this.form.nama_pemegang = data.nama_pemohon
              this.form.tgl_penerbitan = data.tanggal_ttd_mkp
              this.form.npwp = data.npwp_pemohon
              this.form.surat_elektronik = data.email_pemohon
              this.form.alamat_kantor = data.alamat_pemohon
              this.form.no_telepon = data.no_telepon_pemohon
              this.tgl_penerbitan = data.tanggal_ttd_mkp
                ? formatDate(data.tanggal_ttd_mkp, 'DD/MM/YYYY')
                : 'dd/mm/yyyy'
            } else {
              isKkprlAda = false
            }
          })
      }
      if (!isKkprlAda) {
        this.form.nama_pemegang = ''
        this.form.tgl_penerbitan = null
        this.form.npwp = ''
        this.form.surat_elektronik = ''
        this.form.alamat_kantor = ''
        this.form.no_telepon = ''
        this.tgl_penerbitan = 'dd/mm/yyyy'
        Swal.fire(
          'Nomor KKPRL/Nomor OSS tidak tersedia',
          'Silahkan isi form secara manual',
          'info'
        )
      }
    },

    checkFileSize(e, field) {
      const file = e.target.files[0]
      const maxSize = 5 * 1024 * 1024

      if (file && file.size > maxSize) {
        this.errors.add({
          field: field,
          msg: 'Ukuran file maksimal 5MB',
          scope: 'custom',
        })
      } else {
        this.errors.remove(field, 'custom')
      }
    },

    getTahunLaporan() {
      const date = new Date()
      let year = date.getFullYear()
      this.optionTahunLaporan.push({
        value: `${year + 1}`,
        text: `${year + 1}`,
      })
      for (let i = 0; i < 10; i++) {
        this.optionTahunLaporan.push({
          value: `${year}`,
          text: `${year}`,
        })
        year--
      }
    },
  },
}
</script>
